









































import { JbicEntityType } from '@/store/modules/admin/types/admin.types';
import { ToastProgrammatic } from 'buefy';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class DeclineReasonModal extends Vue {
  @Prop() public entityType!: JbicEntityType;

  public reason: string = 'does-not-meet-guideline';
  public reasonOthers: string = '';

  get reasonOptions() {
    return [
      {
        value: 'does-not-meet-guideline',
        label: 'Does not meet submission guidelines'
      },
      { value: 'inappropriate', label: 'Inappropriate or irrelevant content' },
      { value: 'incomplete', label: 'Incomplete details' },
      { value: 'duplicate', label: 'Duplicate submission' },
      { value: 'others', label: 'Others (Specify your reason):' }
    ];
  }

  get entityTitle() {
    if (this.entityType === JbicEntityType.EVENT) {
      return 'Event';
    } else if (this.entityType === JbicEntityType.IMAGE) {
      return 'Image(s)';
    }
  }

  get isOthersDisabled() {
    return this.reason !== 'others';
  }

  validateInput(): boolean {
    if (this.reason.length === 0) {
      return false;
    }
    if (this.reason === 'others' && this.reasonOthers.length === 0) {
      return false;
    }
    return true;
  }

  confirm() {
    if (!this.validateInput()) {
      ToastProgrammatic.open({
        message: `Please select a reason to proceed`,
        type: 'is-danger',
        position: 'is-top'
      });

      return;
    }
    const reasonLabel: string =
      this.reasonOptions.find((option) => option.value === this.reason)
        ?.label ?? '';
    const declineReason: string =
      this.reason === 'others' ? this.reasonOthers : reasonLabel;
    this.$emit('confirm', declineReason);
    this.$emit('close');
  }

  close() {
    this.$emit('close');
  }
}
